import { ChangeDetectorRef, ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { USA_COUNTRY_CODE } from '@constants/constants';
import { CodeRepository } from '@data-layer/repositories';
import { enumIdentifierQualifier } from '@data-layer/enums/common';
import { enumTypeView } from '@enum/enumTypeView';
import { OrganizationsService } from '@services/organizations.service';
import { IErrorForm } from '@shared/form-wrapper/interfaces';
import { ReplaySubject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';

@Component({
  selector: 'organization-address-form',
  templateUrl: './organization-address-form.component.html',
  styleUrls: ['./organization-address-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrganizationAddressFormComponent implements OnInit, OnDestroy {
  @Input() public formGroup: UntypedFormGroup;
  public isUnitedStates: boolean;
  public isDisableCountry: boolean = false;
  public errors: { [name: string]: IErrorForm } = {
    postalCode: {
      maxlength: 'FORM_ERROR.MAX_LENGTH',
    },
  };
  public enumTypeView: typeof enumTypeView = enumTypeView;

  private destroy$: ReplaySubject<boolean> = new ReplaySubject();

  constructor(private organizationsService: OrganizationsService, private cdr: ChangeDetectorRef, private codeRepository: CodeRepository) {}

  public ngOnInit(): void {
    const countryFormControl = this.formGroup.get('address').get('country');
    this.organizationsService.organizationUpdated$.pipe(takeUntil(this.destroy$)).subscribe(() => this.cdr.markForCheck());

    this.isUnitedStates = countryFormControl?.value?.code === USA_COUNTRY_CODE;

    countryFormControl.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((country) => {
      this.isUnitedStates = country.code === USA_COUNTRY_CODE;
      this.cdr.markForCheck();
    });

    const qualifierControl = this.formGroup.get('identifierQualifier');
    this.updateCountryDisableState(qualifierControl?.value);

    qualifierControl?.valueChanges.pipe(takeUntil(this.destroy$)).subscribe((qualifier: enumIdentifierQualifier) => {
      this.updateCountryDisableState(qualifier);
      this.cdr.markForCheck();
    });
  }

  public ngOnDestroy(): void {
    this.destroy$.next();
  }

  private updateCountryDisableState(qualifier: enumIdentifierQualifier): void {
    this.isDisableCountry = qualifier !== enumIdentifierQualifier.ANI && !!qualifier;

    if (this.isDisableCountry) {
      const countryControl = this.formGroup.get('address')?.get('country');
      if (countryControl?.value?.code !== USA_COUNTRY_CODE) {
        this.codeRepository
          .getCountry(USA_COUNTRY_CODE)
          .pipe(take(1))
          .subscribe((country) => {
            countryControl.patchValue(country);
            this.cdr.markForCheck();
          });
      }
    }
  }
}
